import type { ComponentPropsWithoutRef } from 'react'

const ListItem = ({ className = '', ...props }: ComponentPropsWithoutRef<'li'>) => (
  <li className={`flex min-h-13 flex-col flex-wrap ${className}`} {...props} />
)

export default ListItem
